import React from 'react';
import { Container, Button, Row, Col } from 'reactstrap';

import { Text } from '~/components/Text';
import history from '~/services/history';
import { SubHeader } from '~/components/SubHeader';
import ReactGA from 'react-ga4';

import Simples from './Simples';
// import EmMassa from './EmMassa';
// import { ButtonStyled } from './styles';

function NovoLink() {
	// const [painel, setPainel] = useState({
	// 	simples: true,
	// 	em_massa: false,
	// 	recorrente: false,
	// });

	function handleClickSimularCobrancaGA4() {
		ReactGA.event({
			category: "simular_cobranca_link",
			action: `Simular uma cobrança - Lucree por Click`,
			label: `Simulando uma cobrança - Lucree por Click`,
		});
	}

	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Lucree por click',
						link: '/client/maquina-virtual',
					},
					{
						page: 'Novo link',
						link: '/client/novo-link',
					},
				]}
			/>
			<Row className="mt-5 mb-3 border-bottom pb-2">
				<Col md="9" className="d-flex aling-items-center">
					<Text size="large">Novo link</Text>
				</Col>
				<Col md="3" className="d-flex justify-content-end">
					<Button
						className="my-0"
						color="primary"
						onClick={() => {
							handleClickSimularCobrancaGA4();
							history.push('/client/simulador')
						}}>
						Simular uma cobrança
					</Button>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col className="d-flex align-items-center">
					<Text size="big">Gerar novo link</Text>
				</Col>
				<Col>
					<Row>
						{/* <Col>
							<ButtonStyled
								className="w-100"
								disabled={painel.simples}
								onClick={() =>
									setPainel({
										simples: true,
										em_massa: false,
										recorrente: false,
									})
								}>
								Simples
							</ButtonStyled>
						</Col> */}
						{/* <Col>
							<ButtonStyled
								className="w-100"
								disabled={painel.em_massa}
								onClick={() =>
									setPainel({
										simples: false,
										em_massa: true,
										recorrente: false,
									})
								}>
								Em massa
							</ButtonStyled>
						</Col> */}
					</Row>
				</Col>
			</Row>
			<Row>
				<Col>
					<Simples />
					{/* {painel.simples && <Simples />}
					{painel.em_massa && <EmMassa />} */}
					{/* {painel.recorrente && <Recorrente />} */}
				</Col>
			</Row>
		</Container>
	);
}

export default NovoLink;
